// user.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
//import { HttpHelper } from '../shared/http-helper';

import {Observable} from 'rxjs/Rx';
import { AppConfigValues } from '../shared/app-config-values';

import * as _ from 'lodash';

@Injectable()
export class AuthService {
  public serviceUrlPrefix: string;
  token: any;
  public redirectUrl: string;

  constructor(private http: Http) {
    this.serviceUrlPrefix = new AppConfigValues().getApiHostUrl();
  }

  oidclogin(){
    var linkurl = new AppConfigValues().getApiHostUrl();
    window.location.href= linkurl + 'auth/api/account/oidclogin';
    //window.location.href='http://localhost:55706/auth/api/account/oidclogin';
    //return this.http.get('http://localhost:55706/auth/api/account/oidclogin');
  }
  getToken() {
    if (this.token) {
      return this.token;
    }
    else {
      return JSON.parse(sessionStorage.getItem("token"));
    }
  }

  isLoggedIn() {
    return this.getToken() !== null && new Date() < new Date(this.getToken()['.expires']);
  }


  getAccessToken() {
    return this.getToken().access_token;
  }

  setToken(token: any) {
    this.token = token;

    if (token) {
      //think I can do either

      //this seems to be setting the to string of token not the actual json will have to look at that
      //http://vaughnroyko.com/saving-and-loading-objects-or-arrays-in-localstorage
      sessionStorage.setItem("token", JSON.stringify(token));
            //sessionStorage["token"] = token;
    }
    else {
      sessionStorage.removeItem("token");
    }
  }

  getLoggedInUser() {

    if (this.getToken()) {
      return this.getToken().userName;
    }
  }

  getFullName() {

    if (this.getToken()) {
      return this.getToken().fullname;
    }
  }

  getRoles() {
    if (this.getToken())
      return this.getToken().roles;
  }

  isInRole(role: string) {
    //console.log(this.getToken());
    return this.getToken() != null && _.includes(this.getToken().roles.split(','), role);
  }

  isAdmin() {
    return this.getToken() != null && (_.includes(this.getToken().roles.split(','), "System Developer") ||
      _.includes(this.getToken().roles.split(','), "FAA Admin"));
  }

  isRegionalManager() {
    return this.getToken() != null && (_.includes(this.getToken().roles.split(','), "Regional Manager"));
  }
  
  isReadOnly() {
    return this.getToken() != null && (_.includes(this.getToken().roles.split(','), "Read Only"));
  }

  logOut(){
      this.token = null;
			sessionStorage.clear();
  }

  getUserId() {
    if (this.getToken())
      return this.getToken().id;
  }

  login(oidcCode: string): Observable<any> {

    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let options = new RequestOptions({
      headers: headers,
      withCredentials: true
    })
    //will need to call our helper method here 
    return this.http.post(
      `${this.serviceUrlPrefix}token`,
      'grant_type=myaccess&oidcCode=' + encodeURIComponent(oidcCode),
      // { headers: headers }
      options
      )
      .map(this.extractData)
      .do(data => console.log("data" + data))
      .catch(this.handleError)
      .map(data => {
        this.setToken(data);
        return data;
      });
		}


  private handleError(error: any) {
    let body = error.json();
    return Observable.throw(body || { error_description: "Server Error" });
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }
}


/** WEBPACK FOOTER **
 ** ./app/authentication/auth.service.ts
 **/